import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const fetchSliders = createAsyncThunk(
    'slider/fetchSliders',
    async (limit = null, { rejectWithValue }) => {
        try {
            const params = {}
            if(limit != null){
                params.limit = limit
            }
            const response = await callAPIWithoutAuth(
                apiUrls.sliderListing,
                params,
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch categories');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

const sliderSlice = createSlice({
    name: 'slider',
    initialState: {
        sliders: [],
        data: [],
        loadingSlider: false,
        errorSlider: null
    },
    reducers: {
        clearSliderError: (state) => {
            state.error = null;
        },
        clearSliders: (state) => {
            state.sliders = [];
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliders.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSliders.fulfilled, (state, action) => {
                state.loading = false;
                state.sliders = action.payload;
                state.data = action.payload.data || action.payload;
            })
            .addCase(fetchSliders.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});

export const { clearSliderError, clearSliders } = sliderSlice.actions;
export default sliderSlice.reducer;